export default __webpack_public_path__ + "static/media/EM0400.34I-22654_-15118_0.5a4c06a7.jpg";